import { IUser } from '@gig/magic-sdk/dist/adapter/users/user';
// import { config } from '../../config';

declare global {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Window {
        LiveChatWidget: any;
    }
}

export class ChatService {
    maximizeChat() {
        return window.LiveChatWidget?.call('maximize');
    }

    getUserInformation() {
        return window.LiveChatWidget?.get('customer_data');
    }

    // https://developers.livechat.com/docs/extending-ui/extending-chat-widget/javascript-api/#set-customer-name
    setVisitorInfo(
        name?: string,
        email?: string,
        userID?: string,
        username?: string,
    ) {
        // erratic behaviour on 3rd party, no it doesn't accept nulling the data
        window.LiveChatWidget?.call('set_customer_name', name || '');
        window.LiveChatWidget?.call('set_customer_email', email || '');
        window.LiveChatWidget?.call('set_session_variables', {
            userID,
            username,
            email,
        });
    }

    updateLiveChat(user: IUser | null) {
        window.LiveChatWidget?.on('ready', () =>
            this.updateLiveChatPayload(user),
        );
    }

    updateLiveChatPayload(user: IUser | null) {
        const { name, email } = this.getUserInformation();
        const finalName = !!user ? `${user.firstName} ${user.lastName}` : '';

        const shouldUpdateVisitorInfo = !!user
            ? name !== finalName && user.email !== email
            : !!name || !!email;

        if (shouldUpdateVisitorInfo) {
            this.setVisitorInfo(
                finalName,
                user?.email || '',
                user?.userId.toString() || '',
                user?.userName || '',
            );
        }
    }
}
